export default __webpack_public_path__ + "static/media/798.1efacd92.gif";